export function preventDefault(): MethodDecorator {
  return (target: Function, key: string, descriptor: any) => {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const event = args[0];
      if (event instanceof Event) {
        event.preventDefault();
      } else {
        console.warn('First argument of decorated method must be $event object!');
      }
      return originalMethod.apply(this, args);
    };

    return descriptor;
  };
}
